// "Lite" visual mode for TV sticks and other low-power devices: solid panels instead of
// frosted-glass blur, and the Full HD demo video instead of 4K/HDR. Blur over a playing
// 4K video, plus the video itself, can exhaust a Fire TV stick's memory and crash the
// browser app (seen with AbleSign on Fire TV).

export type EffectsMode = 'auto' | 'full' | 'lite';

const TV_UA = /\bAFT[A-Z0-9]*\b|Android TV|GoogleTV|BRAVIA|SMART-TV|SmartTV|Tizen|Web0S|webOS|HbbTV|CrKey|AbleSign|Roku|AppleTV/i;

/** Best guess at whether this device needs Lite mode. */
export function looksLowPower(nav: Pick<Navigator, 'userAgent'> & { deviceMemory?: number } = navigator): boolean {
  if (TV_UA.test(nav.userAgent)) return true;
  // Chrome/WebView report approximate RAM in GB; 2 GB or less struggles with 4K video + blur.
  return typeof nav.deviceMemory === 'number' && nav.deviceMemory <= 2;
}

export function isLite(mode: EffectsMode | undefined): boolean {
  if (mode === 'lite') return true;
  if (mode === 'full') return false;
  try {
    return looksLowPower();
  } catch {
    return false;
  }
}
